import type { Intent } from '@jet/environment/dispatching';

import type { Page } from '../../models';
import type { ActionModel } from '@jet/environment';

/**
 * A response from the router given an incoming (deeplink) URL.
 */
export interface RouterResponse {
    /**
     * The intent to dispatch to get the view model for this URL.
     */
    intent: Intent<Page>;

    /**
     * action to navigate to a new page of the app.
     */
    action: ActionModel;

    /**
     * The storefront present in the URL (ex. "us" or "fr").
     *
     * @remarks
     * If one isn't present, a default is inferred.
     */
    readonly storefront: string;

    /**
     * The locale present in the URL (ex. "en-US" or "fr-CA").
     *
     * @remarks
     * If one isn't present, a default is inferred from the storefront.
     */
    readonly language: string;
}

export interface RouteUrlIntent extends Intent<RouterResponse | undefined> {
    $kind: 'RouteUrlIntent';

    /**
     * The URL to route (ex. "https://podcasts.apple.com/us/show/serial/id123").
     */
    url: string;
}

export function isRouteUrlIntent(
    intent: Intent<unknown>,
): intent is RouteUrlIntent {
    return intent.$kind === 'RouteUrlIntent';
}

export function makeRouteUrlIntent(
    options: Omit<RouteUrlIntent, '$kind'>,
): RouteUrlIntent {
    return { $kind: 'RouteUrlIntent', ...options };
}
